var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.roomTypes
        ? _c(
            "v-container",
            [
              _vm.isValidRoomTypes
                ? _c("ErrorMessage", {
                    attrs: {
                      message: "Необходимо создать хотя бы один тип комнат",
                    },
                  })
                : _vm._e(),
              _vm.roomTypes.length
                ? _c(
                    "v-col",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.togglePanels(
                                    _vm.roomTypes.map(
                                      (item, itemIndex) => itemIndex
                                    )
                                  )
                                },
                              },
                            },
                            [_vm._v(" Развернуть все ")]
                          ),
                          _c("v-divider", { attrs: { vertical: "" } }),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              on: { click: _vm.togglePanels },
                            },
                            [_vm._v(" Свернуть все ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-row",
                {
                  attrs: { "no-gutters": "", align: "center", justify: "end" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("create")
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "pr-1" }, [
                        _vm._v(" mdi-plus "),
                      ]),
                      _c("span", [_vm._v("Создать")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-expansion-panels",
                    {
                      staticClass: "list-group",
                      attrs: { multiple: "", value: _vm.expansionPanels },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "row no-gutters",
                          attrs: { value: _vm.roomTypes, handle: ".handle" },
                          on: {
                            start: _vm.togglePanels,
                            input: function ($event) {
                              return _vm.$emit("list-sort", $event)
                            },
                          },
                        },
                        _vm._l(_vm.roomTypes, function (item, itemIndex) {
                          return _c(
                            "v-expansion-panel",
                            {
                              key: itemIndex,
                              staticClass: "mb-5 list-group-item",
                            },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  transition:
                                                    "scroll-y-transition",
                                                  "offset-y": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return (() => {}).apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  " mdi-dots-vertical "
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  _vm._l(
                                                    _vm.$options.itemOptions,
                                                    function (
                                                      option,
                                                      optionIndex
                                                    ) {
                                                      return _c(
                                                        "v-list-item",
                                                        {
                                                          key: optionIndex,
                                                          style: {
                                                            [option.borderDirection]:
                                                              option.borderStyle,
                                                          },
                                                          attrs: { dense: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.optionHandler(
                                                                option,
                                                                itemIndex,
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                option.title
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("v-row", { attrs: { align: "center" } }, [
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          _vm.errorMessages.$invalid &&
                                          _vm.errorMessages.$dirty
                                            ? "error&#45;&#45;text"
                                            : "",
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.title || itemIndex + 1
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { eager: "" } },
                                [
                                  _c("InputTitleSlug", {
                                    attrs: {
                                      "is-slug-enabled": false,
                                      "is-loading": _vm.loading,
                                      title: item.title,
                                      "title-error": _vm.getFieldErrorMessage(
                                        itemIndex,
                                        "title"
                                      ),
                                    },
                                    on: {
                                      "change:title": function ($event) {
                                        item.title = $event
                                      },
                                    },
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("MediaFilePicker", {
                                            attrs: {
                                              label: "Изображения*",
                                              "file-type":
                                                _vm.$options.mediaTypesByKeys
                                                  .IMAGE,
                                              value: item.images,
                                            },
                                            on: {
                                              change: function ($event) {
                                                item.images = $event
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "preview-bottom",
                                                  fn: function () {
                                                    return [
                                                      _c("ErrorMessage", {
                                                        attrs: {
                                                          message:
                                                            _vm.getFieldErrorMessage(
                                                              itemIndex,
                                                              "images"
                                                            ),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Описание* ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("QuillEditorVue", {
                                        attrs: {
                                          cols: 12,
                                          title: "",
                                          content: item.description,
                                          isShowErrorMessage: true,
                                          errorText: _vm.getFieldErrorMessage(
                                            itemIndex,
                                            "description"
                                          ),
                                          "light-mode": "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            item.description = $event
                                          },
                                          onChangeContent: function ($event) {
                                            return _vm.$emit(
                                              "change:descriptionForMobile",
                                              { itemIndex, descForMob: $event }
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Количество гостей*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.getFieldErrorMessage(
                                                  itemIndex,
                                                  "maxGuests"
                                                ),
                                            },
                                            model: {
                                              value: item.maxGuests,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "maxGuests",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.maxGuests",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Количество взрослых мест*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.getFieldErrorMessage(
                                                  itemIndex,
                                                  "maxAdults"
                                                ),
                                            },
                                            model: {
                                              value: item.maxAdults,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "maxAdults",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.maxAdults",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Количество детских мест*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.getFieldErrorMessage(
                                                  itemIndex,
                                                  "maxChildren"
                                                ),
                                            },
                                            model: {
                                              value: item.maxChildren,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "maxChildren",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.maxChildren",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Базовая цена*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.getFieldErrorMessage(
                                                  itemIndex,
                                                  "basePrice",
                                                  "Обязательное поле. Только числовые значения"
                                                ),
                                            },
                                            model: {
                                              value: item.basePrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "basePrice",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.basePrice",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Удобства")]),
                                          _c("v-select", {
                                            attrs: {
                                              chips: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              outlined: "",
                                              "item-value": "id",
                                              "item-text": "label",
                                              multiple: "",
                                              items: _vm.amenities,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c("v-chip", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.label) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.amenities,
                                              callback: function ($$v) {
                                                _vm.$set(item, "amenities", $$v)
                                              },
                                              expression: "item.amenities",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("ConfirmationDialog", {
                ref: "confirm",
                attrs: { confirmText: "ОК" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }